import React, { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Games from './components/Games';
import FAQ from './components/FAQ';
import Footer from './components/Footer';

function App() {
  const [language, setLanguage] = useState('de'); // Default to German

  const handleLanguageChange = (lang) => {
    setLanguage(lang);
  };

  return (
    <div className="min-h-screen bg-darker">
      {/* Background effects */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 -left-32 w-96 h-96 bg-primary/20 rounded-full blur-3xl animate-pulse-slow"></div>
        <div className="absolute top-3/4 -right-32 w-96 h-96 bg-secondary/20 rounded-full blur-3xl animate-pulse-slow animation-delay-2000"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-accent/5 rounded-full blur-3xl"></div>
      </div>
      
      <div className="relative z-10">
        <Header language={language} onLanguageChange={handleLanguageChange} />
        <Hero language={language} />
        <Features language={language} />
        <Games language={language} />
        <FAQ language={language} />
        <Footer language={language} />
      </div>
    </div>
  );
}

export default App;
